import { processingGroupIdFormat } from "@redotech/redo-ids/ids";
import * as z from "zod";

export const removeSortingTotes = {
  name: "removeSortingTotes" as const,
  input: z.object({
    processingGroupId: processingGroupIdFormat.schema,
    count: z.number().int().positive(),
  }),
  output: z.object({
    success: z.boolean(),
    totesWithInventory: z
      .array(z.object({ toteName: z.string(), totalQuantity: z.number() }))
      .optional(),
  }),
};
